import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '=',
        form: '=',
        course: '='
    },
    template: `
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well table-wrapper" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table class="data01"
                ng-init="vm.initBulk()">
                <thead>
                    <tr>
                        <th><input ng-model="vm.checked" ng-click="vm.toggleAll()" type="checkbox"></th>
                        <th>{{ 'employee.Name' | translate }}</th>
                        <th>{{ 'planning.Position' | translate }}</th>
                        <th>{{ 'planning.Previous date completed' | translate }}</th>
                        <th ng-if="vm.form.model.completionType==vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.INDIVIDUAL">
                            {{ 'planning.Course completion date' | translate }}
                        </th>
                        <th>{{ 'employee.External certificate' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <form-row error="vm.form.errors.pdfFile">
                        <form-row-error></form-row-error>
                        <tr ng-repeat="(index, item) in vm.list.items">
                            <td>
                                <form-row error="vm.form.errors.employees[index].userId">
                                    <input
                                        type="checkbox"
                                        ng-checked="vm.hasUserId(item.id)"
                                        ng-click="$event.stopPropagation();vm.toggleUserId(index, item.id)"
                                        ng-model="vm.form.model.employees[item.id].userId"
                                    >
                                    <form-row-error></form-row-error>
                                </form-row>
                            </td>
                            <td>
                                {{ item.displayName }}
                                <span ng-if="item.hasOptionalTarget" class="badge"> {{ 'occurrence.Optional target' | translate }} </span>
                            </td>
                            <td>
                                <drl-partial-table drls="item.drlsWithValue"></drl-partial-table>
                            </td>
                            <td>{{ vm.getPreviousPassedTime(item.courseUsers) }}</td>
                            <td ng-if="vm.form.model.completionType==vm.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM.KEYS.INDIVIDUAL">
                                <form-row error="vm.form.errors.employees[item.id].completionDate">
                                    <datepicker-api ng-model="vm.form.model.employees[item.id].completionDate"></datepicker-api>
                                    <form-row-error></form-row-error>
                                </form-row>
                            </td>
                            <td class="input">
                                <input
                                    ngf-select="vm.setFile($file, item.id)"
                                    type="file"
                                    ng-model="vm.form.model.files[item.id].file"
                                />
                                <span ng-if="vm.getCertificate(item.id)" class="text">
                                    certificate
                                </span>
                            </td>
                        </tr>
                    </form-row>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, MomentService, DATATABLES, COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.MomentService = MomentService;
        this.DATATABLES = DATATABLES;
        this.COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM = COURSE_HISTORIC_OCCURRENCE_COMPLETION_TYPE_ENUM;
    }

    setFile (file, userId) {
        this.form.model.files[userId].file = file;
        this.form.model.files[userId].fileName = file.name;
    }

    initBulk () {
        this.checked = false;
        this.userIds = [];
        this.form.model.employees = [];
        this.updateShowAddButton();
    }

    toggleAll () {
        if (this.checked) {
            this.userIds = this.list.items
            .map((user) => user.id);

            this.list.items.forEach((user) => {
                this.form.model.employees[user.id] = { userId: user.id };
            });
        }
        else {
            this.userIds = [];
            this.form.model.employees = [];
        }
        this.updateShowAddButton();
    }

    toggleUserId (index, id) {
        if (this.hasUserId(id)) {
            this.lodash.pull(this.userIds, id);
            this.checked = false;
            delete this.form.model.employees[id];
        }
        else {
            this.userIds.push(id);
            // NOTE: without assigning here checked userId would have boolean true value set by angular checkbox
            this.form.model.employees[id].userId = id;
        }

        this.updateShowAddButton();
    }

    hasUserId (id) {
        return this.lodash.includes(this.userIds, id);
    }

    updateShowAddButton () {
        this.showAddButton = this.userIds.length > 0;
        if (!this.showAddButton) {
            this.showNavigationError = false;
        }
    }

    getPreviousPassedTime (courseUsers) {
        const courseUser = this.lodash.find(courseUsers, { courseId: this.course.id });
        if (courseUser && courseUser.previousPassedTime) {
            return this.MomentService.formatTimeStamp(courseUser.previousPassedTime, 'DD.MM.YYYY');
        }
        return '-';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/historicOccurrence/employee/table/index.js